import { Reports } from '../Components/index';

export default Reports;
